/* ==========================================================================
   CKT — INTERNATIONAL INTEREST COUNTER
   ==========================================================================
   We sell only in the United States. A visitor anywhere else gets the region
   gate's "Not available in your country yet" box instead of a buy button.
   This turns that dead end into a queue they can join: one dropdown, one
   button, one tally mark.

   WHAT THIS DOES NOT COLLECT, AND WHY.
   No email. No name. No IP. No cookie, no session, no fingerprint. The only
   thing that leaves this page is a two-letter country code the visitor picked
   from a menu. That is the entire point of the feature and not a first pass at
   it: we stopped selling abroad because we are not equipped for foreign
   privacy obligations, so measuring foreign demand must not create any. A
   country and a count are not personal data and nobody in that table is
   identifiable. Collecting an email here would put us straight back under the
   regime we just stepped out of.

   The country comes from the DROPDOWN, never from their IP. IP geolocation is
   wrong for travellers and anyone on a VPN, and an IP address is arguably
   personal data in its own right. The gate's detected country is used only to
   preselect the menu, as a convenience they can override.

   WHERE THIS APPEARS. Only inside .ckt-region-block, which the region gate in
   layout/theme.liquid paints on product pages for non-US visitors. It is
   deliberately NOT in the footer. The number counts people we TURNED AWAY, so
   on a US shopper's screen it reads as a limitation rather than as demand. In
   front of the person who was turned away it reads as company, and makes them
   likelier to click.

   THE PUBLIC NUMBER is withheld by the SERVER until it crosses a floor (100 by
   default, INTEREST_PUBLIC_FLOOR on Railway). Below that the count is not sent
   at all, so "4 people" cannot be read out of the network tab either. Cold ad
   traffic starting near zero would read as proof that nobody wants this.

   ALIGNMENT follows the house rule set on the policy pages and the FAQ: short
   lines centred, body paragraphs justified with hyphenation on. The single
   exception is the thank-you that replaces the question after a click — it is
   two lines, and justifying two lines opens rivers of white space, so done()
   switches that paragraph back to centred as it swaps the text.

   TO MOVE OR REMOVE IT: this file is loaded by one line in layout/theme.liquid.
   Delete that line and nothing here runs. Nothing else depends on it.
   ========================================================================== */
(function () {
  'use strict';

  var API = 'https://celestialkinthreads-production.up.railway.app';
  var SENT_KEY = 'ckt_interest_sent';
  var GOLD = '#c9a955';
  var JUSTIFY = 'text-align:justify;hyphens:auto;-webkit-hyphens:auto;-ms-hyphens:auto;';

  var COUNTRIES = [
    ["AF", "Afghanistan"],
    ["AL", "Albania"],
    ["DZ", "Algeria"],
    ["AS", "American Samoa"],
    ["AD", "Andorra"],
    ["AO", "Angola"],
    ["AI", "Anguilla"],
    ["AQ", "Antarctica"],
    ["AG", "Antigua and Barbuda"],
    ["AR", "Argentina"],
    ["AM", "Armenia"],
    ["AW", "Aruba"],
    ["AU", "Australia"],
    ["AT", "Austria"],
    ["AZ", "Azerbaijan"],
    ["BS", "Bahamas"],
    ["BH", "Bahrain"],
    ["BD", "Bangladesh"],
    ["BB", "Barbados"],
    ["BY", "Belarus"],
    ["BE", "Belgium"],
    ["BZ", "Belize"],
    ["BJ", "Benin"],
    ["BM", "Bermuda"],
    ["BT", "Bhutan"],
    ["BO", "Bolivia"],
    ["BQ", "Bonaire, Sint Eustatius and Saba"],
    ["BA", "Bosnia and Herzegovina"],
    ["BW", "Botswana"],
    ["BV", "Bouvet Island"],
    ["BR", "Brazil"],
    ["IO", "British Indian Ocean Territory"],
    ["BN", "Brunei Darussalam"],
    ["BG", "Bulgaria"],
    ["BF", "Burkina Faso"],
    ["BI", "Burundi"],
    ["CV", "Cabo Verde"],
    ["KH", "Cambodia"],
    ["CM", "Cameroon"],
    ["CA", "Canada"],
    ["KY", "Cayman Islands"],
    ["CF", "Central African Republic"],
    ["TD", "Chad"],
    ["CL", "Chile"],
    ["CN", "China"],
    ["CX", "Christmas Island"],
    ["CC", "Cocos (Keeling) Islands"],
    ["CO", "Colombia"],
    ["KM", "Comoros"],
    ["CG", "Congo"],
    ["CD", "Congo, The Democratic Republic of the"],
    ["CK", "Cook Islands"],
    ["CR", "Costa Rica"],
    ["HR", "Croatia"],
    ["CU", "Cuba"],
    ["CW", "Curaçao"],
    ["CY", "Cyprus"],
    ["CZ", "Czechia"],
    ["CI", "Côte d'Ivoire"],
    ["DK", "Denmark"],
    ["DJ", "Djibouti"],
    ["DM", "Dominica"],
    ["DO", "Dominican Republic"],
    ["EC", "Ecuador"],
    ["EG", "Egypt"],
    ["SV", "El Salvador"],
    ["GQ", "Equatorial Guinea"],
    ["ER", "Eritrea"],
    ["EE", "Estonia"],
    ["SZ", "Eswatini"],
    ["ET", "Ethiopia"],
    ["FK", "Falkland Islands (Malvinas)"],
    ["FO", "Faroe Islands"],
    ["FJ", "Fiji"],
    ["FI", "Finland"],
    ["FR", "France"],
    ["GF", "French Guiana"],
    ["PF", "French Polynesia"],
    ["TF", "French Southern Territories"],
    ["GA", "Gabon"],
    ["GM", "Gambia"],
    ["GE", "Georgia"],
    ["DE", "Germany"],
    ["GH", "Ghana"],
    ["GI", "Gibraltar"],
    ["GR", "Greece"],
    ["GL", "Greenland"],
    ["GD", "Grenada"],
    ["GP", "Guadeloupe"],
    ["GU", "Guam"],
    ["GT", "Guatemala"],
    ["GG", "Guernsey"],
    ["GN", "Guinea"],
    ["GW", "Guinea-Bissau"],
    ["GY", "Guyana"],
    ["HT", "Haiti"],
    ["HM", "Heard Island and McDonald Islands"],
    ["VA", "Holy See (Vatican City State)"],
    ["HN", "Honduras"],
    ["HK", "Hong Kong"],
    ["HU", "Hungary"],
    ["IS", "Iceland"],
    ["IN", "India"],
    ["ID", "Indonesia"],
    ["IR", "Iran"],
    ["IQ", "Iraq"],
    ["IE", "Ireland"],
    ["IM", "Isle of Man"],
    ["IL", "Israel"],
    ["IT", "Italy"],
    ["JM", "Jamaica"],
    ["JP", "Japan"],
    ["JE", "Jersey"],
    ["JO", "Jordan"],
    ["KZ", "Kazakhstan"],
    ["KE", "Kenya"],
    ["KI", "Kiribati"],
    ["KW", "Kuwait"],
    ["KG", "Kyrgyzstan"],
    ["LA", "Laos"],
    ["LV", "Latvia"],
    ["LB", "Lebanon"],
    ["LS", "Lesotho"],
    ["LR", "Liberia"],
    ["LY", "Libya"],
    ["LI", "Liechtenstein"],
    ["LT", "Lithuania"],
    ["LU", "Luxembourg"],
    ["MO", "Macao"],
    ["MG", "Madagascar"],
    ["MW", "Malawi"],
    ["MY", "Malaysia"],
    ["MV", "Maldives"],
    ["ML", "Mali"],
    ["MT", "Malta"],
    ["MH", "Marshall Islands"],
    ["MQ", "Martinique"],
    ["MR", "Mauritania"],
    ["MU", "Mauritius"],
    ["YT", "Mayotte"],
    ["MX", "Mexico"],
    ["FM", "Micronesia, Federated States of"],
    ["MD", "Moldova"],
    ["MC", "Monaco"],
    ["MN", "Mongolia"],
    ["ME", "Montenegro"],
    ["MS", "Montserrat"],
    ["MA", "Morocco"],
    ["MZ", "Mozambique"],
    ["MM", "Myanmar"],
    ["NA", "Namibia"],
    ["NR", "Nauru"],
    ["NP", "Nepal"],
    ["NL", "Netherlands"],
    ["NC", "New Caledonia"],
    ["NZ", "New Zealand"],
    ["NI", "Nicaragua"],
    ["NE", "Niger"],
    ["NG", "Nigeria"],
    ["NU", "Niue"],
    ["NF", "Norfolk Island"],
    ["KP", "North Korea"],
    ["MK", "North Macedonia"],
    ["MP", "Northern Mariana Islands"],
    ["NO", "Norway"],
    ["OM", "Oman"],
    ["PK", "Pakistan"],
    ["PW", "Palau"],
    ["PS", "Palestine, State of"],
    ["PA", "Panama"],
    ["PG", "Papua New Guinea"],
    ["PY", "Paraguay"],
    ["PE", "Peru"],
    ["PH", "Philippines"],
    ["PN", "Pitcairn"],
    ["PL", "Poland"],
    ["PT", "Portugal"],
    ["PR", "Puerto Rico"],
    ["QA", "Qatar"],
    ["RO", "Romania"],
    ["RU", "Russian Federation"],
    ["RW", "Rwanda"],
    ["RE", "Réunion"],
    ["BL", "Saint Barthélemy"],
    ["SH", "Saint Helena, Ascension and Tristan da Cunha"],
    ["KN", "Saint Kitts and Nevis"],
    ["LC", "Saint Lucia"],
    ["MF", "Saint Martin (French part)"],
    ["PM", "Saint Pierre and Miquelon"],
    ["VC", "Saint Vincent and the Grenadines"],
    ["WS", "Samoa"],
    ["SM", "San Marino"],
    ["ST", "Sao Tome and Principe"],
    ["SA", "Saudi Arabia"],
    ["SN", "Senegal"],
    ["RS", "Serbia"],
    ["SC", "Seychelles"],
    ["SL", "Sierra Leone"],
    ["SG", "Singapore"],
    ["SX", "Sint Maarten (Dutch part)"],
    ["SK", "Slovakia"],
    ["SI", "Slovenia"],
    ["SB", "Solomon Islands"],
    ["SO", "Somalia"],
    ["ZA", "South Africa"],
    ["GS", "South Georgia and the South Sandwich Islands"],
    ["KR", "South Korea"],
    ["SS", "South Sudan"],
    ["ES", "Spain"],
    ["LK", "Sri Lanka"],
    ["SD", "Sudan"],
    ["SR", "Suriname"],
    ["SJ", "Svalbard and Jan Mayen"],
    ["SE", "Sweden"],
    ["CH", "Switzerland"],
    ["SY", "Syria"],
    ["TW", "Taiwan"],
    ["TJ", "Tajikistan"],
    ["TZ", "Tanzania"],
    ["TH", "Thailand"],
    ["TL", "Timor-Leste"],
    ["TG", "Togo"],
    ["TK", "Tokelau"],
    ["TO", "Tonga"],
    ["TT", "Trinidad and Tobago"],
    ["TN", "Tunisia"],
    ["TM", "Turkmenistan"],
    ["TC", "Turks and Caicos Islands"],
    ["TV", "Tuvalu"],
    ["TR", "Türkiye"],
    ["UG", "Uganda"],
    ["UA", "Ukraine"],
    ["AE", "United Arab Emirates"],
    ["GB", "United Kingdom"],
    ["UM", "United States Minor Outlying Islands"],
    ["UY", "Uruguay"],
    ["UZ", "Uzbekistan"],
    ["VU", "Vanuatu"],
    ["VE", "Venezuela"],
    ["VN", "Vietnam"],
    ["VG", "Virgin Islands, British"],
    ["VI", "Virgin Islands, U.S."],
    ["WF", "Wallis and Futuna"],
    ["EH", "Western Sahara"],
    ["YE", "Yemen"],
    ["ZM", "Zambia"],
    ["ZW", "Zimbabwe"],
    ["AX", "Åland Islands"]
  ];

  /* localStorage throws outright in some privacy modes rather than returning
     null, so every read and write is guarded. A visitor with it disabled just
     gets the form again, which is a far better failure than a blank page. */
  function already() {
    try { return window.localStorage.getItem(SENT_KEY) === '1'; }
    catch (e) { return false; }
  }
  function remember() {
    try { window.localStorage.setItem(SENT_KEY, '1'); } catch (e) {}
  }

  function el(tag, css, text) {
    var n = document.createElement(tag);
    if (css) n.style.cssText = css;
    if (text != null) n.textContent = text;
    return n;
  }

  /* The gate publishes the country it detected. It may not have landed yet —
     this script is deferred and the gate waits on a fetch — so treat an absent
     value as "no preselection" rather than waiting for it. */
  function detected() {
    var c = (window.CKT_COUNTRY || '').toUpperCase();
    return /^[A-Z]{2}$/.test(c) ? c : '';
  }

  function build(box) {
    var wrap = el('div', 'margin-top:1.1rem;padding-top:1rem;' +
                         'border-top:1px solid rgba(201,169,85,.28);');
    wrap.className = 'ckt-interest';

    /* The count line, if the server decided it is worth showing. Appended
       above the question when it arrives, so a slow or failed request simply
       means no line rather than a hole in the layout. */
    var countLine = el('p', 'margin:0 0 .7rem;font-size:13px;line-height:1.5;' +
                            'text-align:center;color:' + GOLD + ';display:none;');
    wrap.appendChild(countLine);

    fetch(API + '/interest/count', { mode: 'cors' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.show && typeof d.total === 'number' && d.total > 0) {
          countLine.textContent = "You are not the only one — " + d.total +
            " people outside the United States have asked us to ship there.";
          countLine.style.display = '';
        }
      })
      .catch(function () {});

    if (already()) {
      wrap.appendChild(el('p', 'margin:0;font-size:14px;line-height:1.6;text-align:center;',
        'Thank you — we have your country noted. It genuinely does decide the ' +
        'order we open markets in.'));
      return wrap;
    }

    var q = el('p', 'margin:0 0 .6rem;font-size:14px;line-height:1.6;' + JUSTIFY,
               'Would you buy this if we shipped to you? Tell us where you are ' +
               'and we will know which country to open next.');
    wrap.appendChild(q);

    var row = el('div', 'display:flex;flex-wrap:wrap;gap:.5rem;align-items:center;justify-content:center;');

    var sel = document.createElement('select');
    sel.setAttribute('aria-label', 'Your country');
    sel.style.cssText = 'flex:1 1 12rem;min-width:0;padding:.5rem .6rem;' +
      'font-size:14px;font-family:inherit;border:1px solid rgba(201,169,85,.5);' +
      'border-radius:6px;background:#fff;color:#111;';
    var ph = document.createElement('option');
    ph.value = ''; ph.textContent = 'Choose your country…';
    sel.appendChild(ph);
    var want = detected(), matched = false;
    COUNTRIES.forEach(function (c) {
      var o = document.createElement('option');
      o.value = c[0]; o.textContent = c[1];
      if (c[0] === want) { o.selected = true; matched = true; }
      sel.appendChild(o);
    });
    if (!matched) ph.selected = true;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = 'Tell us';
    btn.style.cssText = 'flex:0 0 auto;padding:.5rem 1.1rem;font-size:14px;' +
      'font-family:inherit;font-weight:600;cursor:pointer;border-radius:6px;' +
      'border:1px solid ' + GOLD + ';background:' + GOLD + ';color:#241c05;';

    var note = el('p', 'margin:.55rem 0 0;font-size:12px;line-height:1.5;opacity:.7;text-align:center;',
      'No email, no name, nothing kept about you — only the country, so we can ' +
      'count it.');

    function done(msg) {
      row.remove();
      note.remove();
      q.style.textAlign = 'center';
      q.style.hyphens = 'manual';
      q.textContent = msg;
    }

    btn.addEventListener('click', function () {
      var code = sel.value;
      if (!code) {
        sel.focus();
        return;
      }
      btn.disabled = true;
      btn.textContent = 'Sending…';
      btn.style.opacity = '.6';

      fetch(API + '/interest', {
        method: 'POST',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ country: code })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('http ' + r.status);
          return r.json();
        })
        .then(function () {
          /* Remembered whether or not the row was written. A repeat click that
             the server throttled still answers ok, and telling this person
             their vote may not have counted would only make them click again. */
          remember();
          done('Thank you — noted. It genuinely does decide the order we open ' +
               'markets in, and we hope to reach you before long.');
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Try again';
          btn.style.opacity = '';
          note.textContent = 'That did not go through — it is us, not you. ' +
            'Please try once more.';
        });
    });

    row.appendChild(sel);
    row.appendChild(btn);
    wrap.appendChild(row);
    wrap.appendChild(note);
    return wrap;
  }

  function attach() {
    var box = document.querySelector('.ckt-region-block');
    if (!box || box.querySelector('.ckt-interest')) return !!box;
    box.appendChild(build(box));
    return true;
  }

  function start() {
    if (attach()) return;
    /* The gate paints its box only after a fetch resolves, and re-paints it if
       the theme re-renders the section. Watch rather than guess at a delay, and
       stop watching after 20s so a page that never shows the box is not left
       with an observer running for the whole visit. */
    var mo;
    try {
      mo = new MutationObserver(function () { attach(); });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { try { mo.disconnect(); } catch (e) {} }, 20000);
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();